import { createFileRoute } from '@tanstack/react-router';

import { fundListScreen, fundListSearch } from '@/modules/fund/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Mesmo caminho do legado (`router.tsx:1861`): o menu aponta para cá pelo `screens.byPath`.
export const Route = createFileRoute('/_app/cadastro/fundos/')({
  validateSearch: fundListSearch,
  staticData: { screen: fundListScreen },
  component: lazyScreen(() => import('@/modules/fund/public').then((module) => ({ default: module.FundListScreen }))),
});
